<script lang="ts">
    import { H2, Label } from "attractions";
    import { onMount } from "svelte";
    import Employee from "../../../Models/Employee";
    export let employeeID: string;

    let employeeDetails;

    onMount(async () => {
        const res = await Employee.getDetails(employeeID);
        employeeDetails = res;
    })
</script>

{#if employeeDetails}
    <section class="reportHeader">
        <Label>Raport dla pracownika</Label>
        <H2>{employeeDetails.firstname} {employeeDetails.lastname}</H2>
    </section>
{/if}

<style lang="scss">
    .reportHeader {
        margin: 2rem 0;
    }
</style>